import { notification, Spin } from 'antd';
import React from 'react';
import { Button, Icon } from 'semantic-ui-react';

import Modal from '../../shared/Modal';
import DoctorReportsStore from './DoctorReportsStore';
import customFetch from '../../../utils/customFetch';

class ModalImport extends React.Component {
  state = { files: null, errorMessage: '' };

  uploadFileTemplate = body => {
    return customFetch('/ExportImport/UploadFileImportSpecialist', {
      method: 'POST',
      body,
    });
  };
  handleUpload = event => {
    const files = event.target.files;
    if (!files || !files.length) {
      return;
    } else {
      const file = files[0];
      const type = /[.]/.exec(file.name) ? /[^.]+$/.exec(file.name)[0] : undefined;
      const size = file.size / 1024 / 1024;
      if (size > 5) {
        notification.destroy();
        return notification.error({
          message: 'Error',
          description: 'The file you have selected is too large. The maximum size is 5MB.',
        });
      } else if (type === 'xls' || type === 'xlsx') {
        DoctorReportsStore.setLoadingUpload(true);
        const formData = new FormData();
        formData.append(files[0].name, files[0]);
        this.uploadFileTemplate(formData)
          .then(res => {
              if (res.status === 'success') {
                notification.destroy();
                notification.success({
                  message: 'Success',
                  description: 'Upload file successfully',
                });
                DoctorReportsStore.setLoadingUpload(false);
              } else {
                notification.destroy();
                return notification.error({
                  message: 'Error',
                  description: 'Upload file failed',
                });
              }
          })
          .catch(() => {});
      } else {
        notification.destroy();
        return notification.error({
          message: 'Error',
          description: 'File type not permitted',
        });
      }
    }
  };

  handleDowloadTemplate = () => {
    window.open('/ExportImport/DownloadSpecialistTemplate', '_blank');
  };

  onCancel = () => {
    return DoctorReportsStore.toggleModal(false, {})();
  };
  render() {
    const { toggleModal, open, modalParams, loadingUpload } = DoctorReportsStore;
    return (
      <React.Fragment>
        <Modal
          visible={open}
          width={1200}
          onCancel={toggleModal(false)}
          title={`Import Specialist`}
          footer={
            <React.Fragment>
              <Button className="negative" onClick={this.onCancel}>
                Close
              </Button>
            </React.Fragment>
          }
        >
          {!this.state.files || !this.state.files.length ? (
            <div className="Modal-UploadProfilePicture">
              <div className="mb-1">
                <p>You can upload one .XLSX file only. Max file size is 500 records.</p>
                <label
                  className="Button"
                  style={{ marginRight: '10px', minWidth: '250px' }}
                  onClick={this.handleDowloadTemplate}
                >
                  <Icon name="download" />
                  <span className="title">Download Template</span>
                </label>
                <label className="Button" style={{ minWidth: '250px' }}>
                  <Icon name="upload" />
                  <span className="title-download">
                    {' '}
                    {modalParams.type === 1 ? <span>Upload Case Managers</span> : <span>Upload Specialists</span>}{' '}
                  </span>
                  <input hidden type="file" onChange={this.handleUpload} />
                </label>
              </div>
            </div>
          ) : null}
          <div className={loadingUpload ? 'uploadcm-loading' : ''}>
            {loadingUpload && <Spin style={{ margin: '0 auto' }} size="large" />}
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}
export default ModalImport;
